export default __webpack_public_path__ + "static/media/green-loose-pin.3c45ecc7.svg";